export default "__VITE_ASSET__BD7XZ$43__"